export const midnight = {
  dark: '#00002B',
  300: '#00004E',
  200: '#202D77',
  100: '#5E6EE9',
  80: '#8692EE',
  60: '#AEB6F4',
  40: '#CFD3F8',
  20: '#EAECFF',
};

export const blue = '#2D7CFF'; // hsl(217, 100%, 59%)
export const blueOnDark = '#5C9AFF'; // hsl(217, 100%, 68%)

export const teal = '#42E1D9'; // hsl(177, 73%, 57%)
export const tealOnLight = '#0FBDB4'; // hsl(177, 85%, 40%)
export const red = '#FF0049';

export const darkBackground = '#1F1F2E'; // hsl(240, 20%, 15%)
export const backgroundSecondaryDark = '#181824';
export const backgroundSecondaryLight = '#f5f5f5'; // MUI grey[100]
